// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f3-a";
export var fulfillmentFormRail = "_f3-9";
export var headerTitleRow = "_f3-c";
export var orderDetailsWrapper = "_f3-7";
export var orderLinkTrigger = "_f3-2";
export var paymentInformationGrid = "_f3-h";
export var paymentSummaryColumn = "_f3-i";
export var shipmentContainer = "_f3-b";
export var shipmentDetailsMainPane = "_f3-8";
export var shipmentNavigationCard = "_f3-5";
export var shipmentNavigationRail = "_f3-3";
export var shipmentNavigationRailHeader = "_f3-4";
export var shipmentSummaryFact = "_f3-e";
export var shipmentSummaryGrid = "_f3-d";
export var shipmentSummaryMetadataRow = "_f3-f";
export var shipmentSummaryTags = "_f3-g";
export var shipmentWorkspace = "_f3-0";
export var shipmentWorkspaceContent = "_f3-6";
export var shipmentWorkspaceHeader = "_f3-1";